// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useContactOptions = () => {
  const { options } = useStaticQuery(graphql`
    query ContactOptions {
      options: wp(global: {}) {
        global {
          contact {
            emailAddress
            fieldGroupName
            facebook
            instagram
            linkedin
            phoneNumber
            twitter
          }
        }
      }
    }
  `);

  return options?.global?.contact;
};

export default useContactOptions;
